import { FC } from 'react';

import { ClockIcon, ExclamationIcon } from '@heroicons/react/outline';

/**
 * 교환신청 완료 · 발송완료 화면과 안내 모달에서 공통으로 쓰는 안내 카드.
 * 1) 유효기간  2) 카카오톡 선물함 아님  (3번 사용 유의사항은 ExchangeCautionNotice)
 */

// 1) 유효기간 안내 (amber)
export const ValidPeriodNotice: FC<{ validPeriod?: string }> = ({ validPeriod }) => (
  <div className="rounded-xl border border-amber-200 bg-amber-50 p-4">
    <div className="flex items-start gap-2.5">
      <ClockIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-amber-600" />
      <div>
        <p className="text-sm font-bold text-amber-900">기프티콘 유효기간 안내</p>
        <p className="mt-1.5 break-keep text-sm leading-relaxed text-amber-800">
          발송된 기프티콘은 발송일로부터{' '}
          <span className="font-bold">{validPeriod || '31일'}</span> 내에 사용하셔야
          합니다.
        </p>
        <p className="mt-1 text-xs text-amber-700">
          기한 내 미사용 시 소멸되며, 복구가 불가합니다.
        </p>
      </div>
    </div>
  </div>
);

// 2) 카카오톡 "선물함"이 아님 (red)
export const GiftBoxNotice: FC = () => (
  <div className="rounded-xl border border-red-200 bg-red-50 p-4">
    <div className="flex items-start gap-2.5">
      <ExclamationIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-red-500" />
      <div>
        <p className="text-sm font-bold text-red-800">
          카카오톡 &quot;선물함&quot;이 아닙니다
        </p>
        <p className="mt-1.5 break-keep text-sm leading-relaxed text-red-700">
          기프티콘은 <span className="font-bold">문자(MMS) 또는 카카오톡 알림톡</span>으로
          발송됩니다.
        </p>
        <p className="mt-1 break-keep text-xs leading-relaxed text-red-600">
          카카오톡 선물함이 아닌, 받으신 문자 또는 알림톡에서 기프티콘 이미지를 확인하여
          매장에서 제시해 주세요.
        </p>
      </div>
    </div>
  </div>
);
